export default __webpack_public_path__ + "static/media/cover_placeholder_3x.06473245.webp";